/* eslint-disable max-len */
import React, { useEffect } from 'react';
import './CompanyProfile.scss';

export default function CompanyProfile() {
  useEffect(() => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'instant',
    });
  }, []);

  useEffect(() => {
    const header = document.querySelector('.Header.fixed');
    const companyProfile = document.querySelector('.CompanyProfile');
    const footer = document.querySelector('.Footer');
    const minimumRequiredHeight = document.documentElement.clientHeight - (header.offsetHeight + footer.offsetHeight);

    companyProfile.style.minHeight = `${minimumRequiredHeight}px`;
  }, []);

  return (
    <section className="CompanyProfile">
      CompanyProfile
    </section>
  );
}
